<template>
  <router-link :to="redirectLink" class="no-underline">
    <BlCardMv
      :shadow="false"
      :class="!isHideBorder && 'border border-solid border-[#E0E0E0]'"
      class="lihat-semua-card flex h-full rounded bg-white w-36 justify-center items-center flex-col"
    >
      <div class="mb-12 w-7 h-7 rounded-full border border-solid border-[#2b4ac7] flex justify-center items-center">
        <IcoChevronRightMinor size="small" color="#2b4ac7" class="w-5 h-5" />
      </div>
      <BlTextAv weight="bold" variation="body-14" tag="p" color="link-01">Lihat Semua</BlTextAv>
    </BlCardMv>
  </router-link>
</template>

<script>
import {IcoChevronRightMinor} from '@bukalapak/bazaar-visual-next';
import {BlTextAv, BlCardMv} from '@bukalapak/bazaar-mweb-latest';

export default {
  name: 'LihatSemuaCard',
  components: {IcoChevronRightMinor, BlTextAv, BlCardMv},
  props: {
    redirectLink: {
      type: String,
      default: '/',
    },
    isHideBorder: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
